import React from "react";
import { useIntl } from "react-intl";
import { Tooltip, Descriptions } from "antd";

import CashOnDeliveryIcon from "../cashOnDeliveryIcon";

import "./index.css";

const { Item } = Descriptions;

const ConsignmentInfo = ({ consignment }) => {
  const intl = useIntl();
  const { cashOnDelivery } = consignment;
  return (
    <Descriptions
      bordered
      column={1}
      size="small"
      colon={false}
      className="consignment-info"
      title={intl.formatMessage({
        id: "tracking.information",
        defaultMessage: "Informace o zásilce",
      })}
    >
      <Item
        label={intl.formatMessage({
          id: "tracking.consignment.code",
          defaultMessage: "Kód zásilky",
        })}
      >
        <Tooltip
          title={
            consignment.orderCode &&
            intl.formatMessage(
              {
                id: "tracking.consignment.orderCode",
                defaultMessage: "Kód objednávky {orderCode}",
              },
              { orderCode: consignment.orderCode }
            )
          }
        >
          {consignment.code}
        </Tooltip>
      </Item>
      <Item
        label={intl.formatMessage({
          id: "tracking.consignment.sender",
          defaultMessage: "Místo odesílatele",
        })}
      >
        {consignment.sender || "--"}
      </Item>
      <Item
        label={intl.formatMessage({
          id: "tracking.consignment.customerReference",
          defaultMessage: "Zákaznická reference",
        })}
      >
        {consignment.customerReference || "--"}
      </Item>
      <Item
        label={intl.formatMessage({
          id: "tracking.consignment.countOfCollis",
          defaultMessage: "Počet kusů",
        })}
      >
        {consignment.countOfCollis || "--"}
      </Item>
      <Item
        label={intl.formatMessage({
          id: "tracking.consignment.weight",
          defaultMessage: "Váha",
        })}
      >
        {consignment.weight ? `${consignment.weight} kg` : "--"}
      </Item>
      <Item
        label={intl.formatMessage({
          id: "tracking.consignment.cashOnDelivery",
          defaultMessage: "Dobírka",
        })}
      >
        {cashOnDelivery ? (
          cashOnDelivery.amount ? (
            `${cashOnDelivery.amount} ${cashOnDelivery.currency || "CZK"}`
          ) : (
            <CashOnDeliveryIcon valid />
          )
        ) : (
          <CashOnDeliveryIcon />
        )}
      </Item>
    </Descriptions>
  );
};

export default ConsignmentInfo;
